import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { useSelector } from "react-redux";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";

const ViewVendor = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [blReason, setBLReason] = useState("");
  const [refresh, setRefresh] = useState(false);
  const user = useSelector((store) => store?.login.user);
  let { id } = useParams();
  const [vendorDealsInMaterial, setVendorDealsInMaterial] = useState();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `vendor/getVendorById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setVendorDealsInMaterial(res?.data?.vendorDealsInMaterial);
        } else {
          Toast("error", "Error while getting Lead!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  const handelSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("isBlacklisted", true);
    formData.append("blacklistReason", blReason);
    const headers = { "Content-Type": "multipart/form-data" };
    performRequest("PATCH", `/vendor/updateVendor/${id}`, formData, headers)
      .then((res) => {
        if (res.status === 200) {
          document.getElementById("modal-close").click();
          setRefresh(!refresh);
          Toast("success", "Vendor updated successfully!");
        } else {
          document.getElementById("modal-close").click();
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        document.getElementById("modal-close").click();
        CustomErrorResponse(err);
      });
  };

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Vendor Management</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Vendor</h2>
            </div>

            <div className="card-body">
              <div className="row row-cards row-deck">
                <div className="col-md-6">
                  <div className="card p-3">
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Business name{" "}
                        </label>
                        <div className="w-100 col">
                          {(data?.businessName || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Contact person name{" "}
                        </label>
                        <div className="w-100 col">
                          {(data?.contactPersonName || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Phone number
                        </label>
                        <div className="w-100 col">
                          {data?.contactPersonPhone}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Alternative phone number
                        </label>
                        <div className="w-100 col">
                          {data?.alternateContactPersonPhone || "N/A"}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Business email
                        </label>
                        <div className="w-100 col">
                          {(data?.contactPersonEmail || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Reffered by
                        </label>
                        <div className="w-100 col">
                          {data?.referredBy || "N/A"}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Business Address
                        </label>
                        <div className="w-100 col">
                          {(data?.businessAddress || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">State</label>
                        <div className="w-100 col">
                          {(`${data?.state}` || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )}

                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">Notes</label>
                        <div className="w-100 col">
                          {(
                            data?.notes || "Note is not available"
                          ).toUpperCase()}
                        </div>
                      </div>
                    )}

                    {/* <div className="card p-3 mb-3 ">
                    <label className="w-25 form-label col">Notes</label>
                      <div className="w-100 col">
                        {(data?.notes || "Note is not available").toUpperCase()}
                      </div>
                    </div> */}

                    {data && data?.isBlacklisted && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Blacklist status
                        </label>
                        <div className="w-100 col">
                          <span className="badge bg-red  text-white">
                            Blacklisted
                          </span>
                        </div>
                      </div>
                    )}
                    {data && data?.isBlacklisted && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Blacklist reason
                        </label>
                        <div className="w-100 col">
                          {data?.blacklistReason || "N/A"}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card p-3">
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Gst number
                        </label>
                        <div className="w-100 col">
                          {(data?.gstNumber || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Bank account name
                        </label>
                        <div className="w-100 col">
                          {(data?.bankAccountName || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Bank account number
                        </label>
                        <div className="w-100 col">
                          {(data?.bankAccountNumber || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">Bank IFSC</label>
                        <div className="w-100 col">
                          {(data?.bankIFSC || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Business nature
                        </label>
                        <div className="w-100 col">
                          {(data?.businessNature || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Legal Constitution
                        </label>
                        <div className="w-100 col">
                          {(data?.legalConstitution || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )}
                    {/* {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">Notes</label>
                        <div className="w-100 col">
                          {(data?.notes || "N/A").toUpperCase()}
                        </div>
                      </div>
                    )} */}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          GST certificate
                        </label>
                        <div className="w-100 col">
                          {data.gstCertificate ? (
                            <LazyImageComponent
                              width="70%"
                              src={data.gstCertificate}
                              alt={"gstCertificate"}
                            />
                          ) : (
                            "N/A"
                          )}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Vendor registration
                        </label>
                        <div className="w-100 col">
                          {data.vendorReg ? (
                            <LazyImageComponent
                              width="70%"
                              src={data.vendorReg}
                              alt={"vendorReg"}
                            />
                          ) : (
                            "N/A"
                          )}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Vendor agreement
                        </label>
                        <div className="w-100 col">
                          {data.vendorAgreement ? (
                            <LazyImageComponent
                              width="70%"
                              src={data.vendorAgreement}
                              alt={"vendorAgreement"}
                            />
                          ) : (
                            "N/A"
                          )}
                        </div>
                      </div>
                    )}
                    {data && (
                      <div className="mb-3 row">
                        <label className="w-25 form-label col">
                          Vendor bank passbook
                        </label>
                        <div className="w-100 col">
                          {data.vendorBankPassbook ? (
                            <LazyImageComponent
                              width="70%"
                              src={data.vendorBankPassbook}
                              alt={"vendorBankPassbook"}
                            />
                          ) : (
                            "N/A"
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="card p-3">
                    <h3 className="p-1">Vendor deals in:</h3>
                    {vendorDealsInMaterial &&
                      vendorDealsInMaterial.length > 0 && (
                        <div className="row row-card row-deck">
                          {vendorDealsInMaterial?.map((val, index) => {
                            return (
                              <div
                                key={val.id}
                                className="col-lg-3 col-md-4 col-6 my-2"
                              >
                                <div className="card text-center p-2 justify-content-center px-md-4">
                                  <img
                                    width={"60%"}
                                    className="m-auto"
                                    src={val.image}
                                    alt={val.diseasesName}
                                  />

                                  <h3 className="m-auto mb-0">{`${val.item}`}</h3>
                                  <p className="m-auto my-0">
                                    {val.specifications}
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                  </div>
                </div>
                {data?.customDeal && (
                  <div className="col-12">
                    <div className="card p-3">
                      <h3 className="p-1">Vendor deals in custom items:</h3>
                      <div className="mb-3  row">
                        <div className="col-3 ">
                          <div
                            className="card p-2 text-center"
                            style={{ fontWeight: "bold" }}
                          >
                            {data?.customDeal || "N/A"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                {(user.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  user?.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                  <button
                    disabled={data?.isBlacklisted}
                    className={`btn mx-1 mt-2 btn-danger`}
                    data-bs-toggle="modal"
                    data-bs-target="#modal-team"
                  >
                    BLACKLIST VENDOR
                  </button>
                )}
                <SimpleButton
                  buttonText="Edit Vendor"
                  href={`/purchase-vendor-management/edit-vendor/${id}`}
                />
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal modal-blur fade"
          id="modal-team"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add to blacklist</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <form onSubmit={handelSubmit}>
                <div className="modal-body">
                  <div>
                    <label className="form-label required">
                      Blacklist reason
                    </label>
                    <textarea
                      onChange={(e) => setBLReason(e.target.value)}
                      required
                      rows={5}
                      className="form-control"
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    id="modal-close"
                    type="button"
                    className="btn me-auto"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-danger">
                    Blacklist vendor
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewVendor;
